/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Icon, IconButton, LinearProgress } from "@mui/material";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataPaginateTable from "examples/Tables/DataPaginateTable";
import NotificationItem from "examples/Items/NotificationItem";

import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import { URL_API } from "config";
import MDInput from "components/MDInput";
import { useAuthContext } from "context/AuthContext";
import moment from "moment";

function CompanyTable() {
  const [companies, setCompanies] = useState([]);

  const [rowSelected, setRowSelected] = useState();

  const [loading, setLoading] = useState(false);

  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const [isMounted, setIsMounted] = useState(true);

  var [filter, setFilter] = useState();
  const navigate = useNavigate();

  const { user } = useAuthContext();

  var dataTableData = {
    columns: [
      { Header: "Data de adesão", accessor: "accession_date", width: "7%" },
      { Header: "Nome", accessor: "name", width: "20%" },
      { Header: "CNPJ", accessor: "cnpj", width: "25%" },
      { Header: "StatusCompanyUser", accessor: "status", width: "7%" },
      { Header: "UUID", accessor: "uuid" },
      { Header: "Ações", accessor: "action", width: "7%" },
    ],
    rows: companies,
  };

  let tag = localStorage.getItem("Tag");

  const getCompanies = async (page = 1, limit = 10) => {
    await axios
      .get(
        URL_API +
        `/companies?page=${page}&limit=${limit}${filter ? `&filter=${filter}` : ""
        }`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        if (isMounted) {
          const list = [];

          for (const company of response.data.data) {
            Object.assign(company, { accession_date: moment(company.created_at).format('DD/MM/YYYY') })

            list.push(company)
          }

          setCompanies(list);
          setTableTotal(response?.data.meta?.total);
        }
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    (async () => {
      setLoading(true);

      if (user?.profile !== 99) navigate("/admin/dashboard");

      getCompanies(tablePage, tableLimit);

      setLoading(false);

      return () => {
        setIsMounted(false);
      };
    })()
  }, [tablePage, tableLimit]);

  async function updateCompany(company) {
    await axios
      .put(URL_API + `/company/${company.uuid}`, company, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(() => { })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });

    getCompanies(tablePage, tableLimit);
  }

  async function onDisable(params) {
    params.status = 2;

    await updateCompany(params);
  }

  async function onEnable(params) {
    params.status = 1;

    await updateCompany(params);
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtro para Companhia
                </MDTypography>
              </MDBox>
              <MDBox
                p={1}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid container spacing={2}>
                  <Grid item>
                    <MDInput
                      label="Buscar por companhia..."
                      onChange={async (event) => {
                        const { value } = event.target;
                        if (value && value !== "") setFilter(value);
                        else {
                          getCompanies(tablePage, tableLimit);
                          setTablePage(1);
                          setFilter("");
                        }
                      }}
                      size="large"
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={async () => await getCompanies(tablePage, tableLimit)}
                      sx={{
                        color: "#fff",
                        background: "#3f50b5",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "blue",
                        },
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Companhias
                </MDTypography>
                <MDButton
                  color="light"
                  onClick={() => {
                    navigate("/admin/companhias/criar");
                  }}
                >
                  Nova
                </MDButton>
              </MDBox>
              {
                loading ?
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress sx={{ overflow: 'hidden' }} />
                  </Box> :
                  <DataPaginateTable
                    entriesPerPage={{ defaultValue: tableLimit }}
                    table={dataTableData}
                    onRowSelected={setRowSelected}
                    setTableLimit={setTableLimit}
                    tableLimit={tableLimit}
                    setTablePage={setTablePage}
                    tablePage={tablePage}
                    tableTotal={tableTotal}
                  >
                    <NotificationItem
                      onClick={() =>
                        navigate(
                          "/admin/companhias/atualizar/" + rowSelected.original.uuid
                        )
                      }
                      icon={<Icon>create</Icon>}
                      title="Editar"
                    />

                    {rowSelected?.original?.status === 1 ? (
                      <NotificationItem
                        onClick={() => {
                          onDisable(rowSelected.original);
                          navigate("/admin/companhias");
                        }}
                        icon={<Icon>block</Icon>}
                        title="Desativar"
                      />
                    ) : (
                      <NotificationItem
                        onClick={() => {
                          onEnable(rowSelected.original);
                          navigate("/admin/companhias");
                        }}
                        icon={<Icon>check</Icon>}
                        title="Ativar"
                      />
                    )}
                  </DataPaginateTable>
              }

            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}

export default CompanyTable;
